"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bardi": {
    "c000f1c3": [{
      "hkey": "7efa7c6c",
      "slug": "bardi",
      "name": "Bardi",
      "primary": true,
      "skipSearch": false
    }],
    "boccolo-de-tassi": [{
      "hkey": "7efa7c6c",
      "slug": "bardi",
      "name": "Bardi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b417ebdc": [{
      "hkey": "7efa7c6c",
      "slug": "bardi",
      "name": "Bardi",
      "primary": true,
      "skipSearch": false
    }],
    "campello": [{
      "hkey": "7efa7c6c",
      "slug": "bardi",
      "name": "Bardi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e2871143": [{
      "hkey": "7efa7c6c",
      "slug": "bardi",
      "name": "Bardi",
      "primary": true,
      "skipSearch": false
    }],
    "casanova": [{
      "hkey": "7efa7c6c",
      "slug": "bardi",
      "name": "Bardi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "186e9389": [{
      "hkey": "7efa7c6c",
      "slug": "bardi",
      "name": "Bardi",
      "primary": true,
      "skipSearch": false
    }],
    "comune-stradella": [{
      "hkey": "7efa7c6c",
      "slug": "bardi",
      "name": "Bardi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7c06f4a2": [{
      "hkey": "7efa7c6c",
      "slug": "bardi",
      "name": "Bardi",
      "primary": true,
      "skipSearch": false
    }],
    "credarola": [{
      "hkey": "7efa7c6c",
      "slug": "bardi",
      "name": "Bardi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "96ba2b8b": [{
      "hkey": "7efa7c6c",
      "slug": "bardi",
      "name": "Bardi",
      "primary": true,
      "skipSearch": false
    }],
    "gravago": [{
      "hkey": "7efa7c6c",
      "slug": "bardi",
      "name": "Bardi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cfdb5504": [{
      "hkey": "9c89543b",
      "slug": "brugnoli",
      "name": "Brugnoli",
      "primary": true,
      "skipSearch": false
    }],
    "rugarlo": [{
      "hkey": "9c89543b",
      "slug": "brugnoli",
      "name": "Brugnoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "976bbf42": [{
      "hkey": "7efa7c6c",
      "slug": "bardi",
      "name": "Bardi",
      "primary": true,
      "skipSearch": false
    }],
    "santa-giustina": [{
      "hkey": "7efa7c6c",
      "slug": "bardi",
      "name": "Bardi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;